module.exports = __webpack_public_path__ + "img/music-player.028180f3.svg";